import Header from '../../components/Header/Header';
import Title from '../../components/Title/Title';
import './Contato.css';
import ConsultorForm from '../../components/Forms/ConsultorForm';
import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { PageSeo } from '../../seo/Seo';

export default function Contato() {
    const { t } = useTranslation();
    // Latitudes endereços Calriz
    var latitudeBr = -23.558728694700385;
    var longitudeBr = -46.661249061424066;
    var latitudeEua = 28.450964;
    var longitudeEua = -81.482655;
    const [endereco,setEndereco] = useState(`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1828.6352198069487!2d${longitudeBr}!3d${latitudeBr}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce576f5daa5821%3A0xde33ef2312dd39c7!2sCalriz%20Sistemas%20Ltda!5e0!3m2!1sen!2sbr!4v1757011432730!5m2!1sen!2sbr`);
    
    // Função que altera no mapa conforme o click
    const handleclickBr = ()=>{
    setEndereco(`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1828.6352198069487!2d${longitudeBr}!3d${latitudeBr}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce576f5daa5821%3A0xde33ef2312dd39c7!2sCalriz%20Sistemas%20Ltda!5e0!3m2!1sen!2sbr!4v1757011432730!5m2!1sen!2sbr`);
}
    const handleclickEua = ()=>{
    setEndereco(`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3507.948175299205!2d${longitudeEua}!3d${latitudeEua}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e77fa8715136dd%3A0x2cdc8c3304c14320!2s7345%20W%20Sand%20Lake%20Rd%20Ste%20210%2C%20Orlando%2C%20FL%2032819%2C%20EUA!5e0!3m2!1spt-BR!2sbr!4v1757692224114!5m2!1spt-BR!2sbr`);
        

}

    return (
        <div className='contato-page'>
            <PageSeo page="contato" path="/contato" />
            <Header />
            <Title>{t('contato.title', 'Contato')}</Title>

            <div className='contato-container'>
                <div className="mapa-container">
                    <div className="contato-mapa">
                        <iframe src={endereco} width="600" height="450" loading="lazy" ></iframe>
                    
                    </div>
                    <div className="contato-info">
                        <div onClick={handleclickBr} className="contato-item">
                            <span className="contato-icon location"></span>
                            <span>1301 Horsa I - Av. Paulista, 2073 - Conjunto Nacional - Bela Vista, São Paulo - SP, 01311-940</span>
                        </div>
                        <div onClick={handleclickEua} className="contato-item">
                            <span className="contato-icon location"></span>
                            <span>7345 W Sand Lake Rd - Orlando - FL 32819 - EUA</span>
                        </div>
                        <div className="contato-item">
                            <span className="contato-icon phone"></span>
                            <span>+55 (11) 2394-7253</span>
                        </div>
                        <div className="contato-item">
                            <span className="contato-icon email"></span>
                            <span>contato@calriz.com</span>
                        </div>
                    </div>
                </div>
                <div className='form-container'>
                        <ConsultorForm />
                </div>
            </div>
        </div>
    );
}